var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32.5C25.8366 32.5 33 25.3366 33 16.5C33 7.66344 25.8366 0.5 17 0.5C8.16344 0.5 1 7.66344 1 16.5C1 25.3366 8.16344 32.5 17 32.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04828 7.5L14.6934 17.7259L7 26.04H8.73148L15.467 18.7609L20.9092 26.04H26.8015L18.7262 15.2389L25.8872 7.5H24.1557L17.9526 14.2039L12.9406 7.5H7.04828ZM9.59455 8.77586H12.3015L24.2548 24.7639H21.5479L9.59455 8.77586Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXHover);
export default __webpack_public_path__ + "static/media/x-hover.82a43a102fb6e9a0f8f35dfe326ec3a8.svg";
export { ForwardRef as ReactComponent };